import GenericModalComponent from "../utils/GenericModalComponent";

class InviteFriendModalComponent {

    constructor(code) {
        this.element = document.querySelector('.invite-friend-modal');
        if (!this.element) return;
        this.sharedData = {};
        this.code = code;
        this.modal = new GenericModalComponent(this.element);
        this.closeButton = document.querySelector('.invite-friend-modal__close');
        this.shareButtons = this.element.querySelectorAll('.invite-friend-modal__social-icons img');
        this.addShareListener();
    }

    addShareListener() {
        this.initShareData();
        if (!navigator.canShare()) this.addShareDesktop(); //  : this.addShareMobile();
    }

    addShareDesktop() {
        this.shareButtons.forEach((button) => {
            button.addEventListener('click', () => this.share(button));
        });
    }


    share(element) {
        const url = this.getUrlToShare(element);
        if (!url) return;
        window.open(url, '_blank');
    }

    getUrlToShare(element) {
        const type = element.dataset.shareType;
        const text = encodeURIComponent(this.sharedData.text);
        const title = encodeURIComponent(this.sharedData.title);

        switch (type) {
            case 'telegram':
                return 'https://t.me/share/url?url=' + this.sharedData.url + '&text=' + text;
            case 'mail':
                return 'mailto:?subject=' + title + '&body=' + text;
            case 'whatsapp':
                return 'https://api.whatsapp.com/send?text=' + text;
        }
    }

    shareMobile() {
        try {
            navigator.share(this.sharedData).then(() => {
                console.log("Native share popup opened!");
            });
        } catch (e) {
        }
    }


    startModal() {
        navigator.canShare() ? this.shareMobile() : this.modal.openModal();
    }

    initShareData() {
        this.sharedData.title = 'DLovers';
        this.sharedData.text = `Ciao! Ecco il mio codice amico: ${this.code}, clicca qui per saperne di piu: ${window.location.origin}`;
        this.sharedData.url = window.location.origin + '/';
    }

    init() {
        this.startModal();
    }
}

export default InviteFriendModalComponent;
